util = require("./util.coffee")

# Gets the value of a localStorage does a check for expiry
# so we can remove localstorage that has expired.
# falls back to cookies if localstorage fails
getLocalStorage = (name) ->
    # if the key is expired, we will return null
    try
        storedItem = JSON.parse(localStorage.getItem(name))
    catch
        # fallback to cookies if we can't get localstorage
        cookieValue = util.getCookie(name)
        storedItem = if cookieValue then JSON.parse(decodeURIComponent(cookieValue))

    # if we successfully got an item, we check if it's
    # expired and delete it and return null.
    if storedItem?.expiry
        date = new Date()
        if date.getTime() >= storedItem.expiry
            deleteLocalStorage(name)
            return null

    storedItem?.value
        

# Sets a localstorage with the number of days before expire
# checks if it's expired before setting and falls back to
# cookies if set
#
# @param [String] name the key of the localstorage item
# @param [Object or String] value to store. will be JSON.stringify'd
# @param [Number] days before the key expires
# @param [Boolean] cookiefallback store in cookies if ls is not available
#
setLocalStorage = (name, value, days, cookiefallback=true) ->
    lsObj = {value: value}

    # if we pass an expiration date - add an expiry property
    if days?
        date = new Date()
        date.setTime(date.getTime() + days*24*60*60*1000)
        lsObj.expiry = date.getTime()

    storageObj = JSON.stringify(lsObj)

    try
        localStorage.setItem(name, storageObj)
    catch
        # we failed, we can't use localstorage so lets use a cookie
        if not cookiefallback
            return false
        encoded = encodeURIComponent(storageObj)
        util.setCookie(name, encoded, days, "/")

    true


# removes they key (name) from localstorage with fallback to cookie
deleteLocalStorage = (name) ->
    try
        localStorage.removeItem(name)
    catch
        # failed removing from localstorage remove from cookie?
        util.deleteCookie(name)


module.exports = {
    getLocalStorage: getLocalStorage,
    setLocalStorage: setLocalStorage,
    deleteLocalStorage: deleteLocalStorage
}


// WEBPACK FOOTER //
// ./node_modules/musecoreui/util/storage_util.coffee